import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import Unauthorized from "components/UI/Unauthorized";
import { usePermissions } from "context/PermissionsContext";

function Dashboard() {
  const { hasPermission } = usePermissions();
  const pagesList = [
    {
      name: t("lang.dashboard"),
      route: "",
    },
  ];
  if (!hasPermission("can_view_kafka")) {
    return <Unauthorized />;
  }
  return (
    <DashboardLayout>
      <DashboardNavbar pagesList={pagesList} />
      <Card>
        <SoftBox p={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <h1>{t("lang.dashboard")}</h1>
            </Grid>
          </Grid>
        </SoftBox>
      </Card>
    </DashboardLayout>
  );
}

export default Dashboard;
